
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { DigitalRoutingModule } from "./digital-routing.module";
import { OrderNowComponent } from './order-now/order-now.component';
import { SearchOrderReceivedComponent } from './search-order-received/search-order-received.component';
import { ConfirmOrderComponent } from './confirm-order/confirm-order.component';
import { ConfirmOtpComponent } from './confirm-otp/confirm-otp.component';
import { DetailOrderComponent } from './detail-order/detail-order.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

@NgModule({
    declarations: [
        OrderNowComponent,
        SearchOrderReceivedComponent,
        ConfirmOrderComponent,
        ConfirmOtpComponent,
        DetailOrderComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        DigitalRoutingModule,
        MaterialModule,
        Ng4LoadingSpinnerModule.forRoot()
    ],
    exports: [
    ],
    entryComponents: [
    ],
    providers: []
})
export class DigitalModule { }
